import api from './api';
import { unwrapList } from './unwrapList';
import { Tag, TagFormData } from '../types/tag';

export const tagService = {
    // Get all tags
    // GET /tags é paginado (default 10, máx 100 por página): percorre todas as
    // páginas, senão quem tem mais de 10 etiquetas só enxerga as 10 primeiras.
    getTags: async (): Promise<Tag[]> => {
        const tags: Tag[] = [];
        let page = 1;
        let lastPage = 1;
        do {
            const response = await api.get('/tags', { params: { per_page: 100, page } });
            tags.push(...unwrapList<Tag>(response.data));
            lastPage = Number((response.data as any)?.meta?.last_page) || page;
            page++;
        } while (page <= lastPage);
        return tags;
    },

    // Create a new tag
    createTag: async (data: TagFormData): Promise<Tag> => {
        const response = await api.post('/tags', data);
        return (response.data as any).data;
    },

    // Update a tag
    updateTag: async (id: number, data: TagFormData): Promise<Tag> => {
        const response = await api.put(`/tags/${id}`, data);
        return (response.data as any).data;
    },

    // Delete a tag
    deleteTag: async (id: number): Promise<void> => {
        await api.delete(`/tags/${id}`);
    },

    // Attach tags to an image
    attachTagsToImage: async (imageId: number, tagIds: number[]): Promise<any> => {
        const response = await api.post(`/images/${imageId}/tags`, { tag_ids: tagIds });
        return (response.data as any).data;
    },

    // Detach a tag from an image
    detachTagFromImage: async (imageId: number, tagId: number): Promise<any> => {
        const response = await api.delete(`/images/${imageId}/tags/${tagId}`);
        return (response.data as any).data;
    },

    // Sync tags for an image (replace all)
    syncTagsForImage: async (imageId: number, tagIds: number[]): Promise<any> => {
        const response = await api.put(`/images/${imageId}/tags`, { tag_ids: tagIds });
        return (response.data as any).data;
    }
};

export default tagService;
